<template>
  <div class="process-content" style="overflow:hidden;">
    <el-upload
      ref="uploader"
      class="drop-uploader"
      drag
      action
      :limit="1"
      :headers="headers"
      :file-list="fileList"
      :auto-upload="false"
      :show-file-list="false"
      :on-change="toChooseFile"
      style="height: 32px;"
    >
      <div class="drop-uploader-icon">
        <p style="display: inline-block;">{{ $t('SeaExport.UploadFile') }}</p>
      </div>
    </el-upload>
    <div v-if="fileList && fileList.length > 0" style="margin-top: 10px;cursor: pointer;">
      <div v-for="(file, index) in fileList" :key="index" class="file-style">
        <div style="margin: 7px;display: flex;">
          <i class="el-icon-paperclip" />
          <span class="file-name">{{ file.fileName }}</span>
          <span style="color: darkgray;">{{ WorkflowUtil.fileSizeLabel(file.fileSize) }}</span>
          <i style="float: right;" class="el-icon-close" @click="remove(file.fileId)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'

export default {
  name: 'ProcessFile',
  props: {
    fileList: { type: Array, default: () => {} }
  },
  data() {
    return {
      WorkflowUtil: WorkflowUtil
    }
  },
  computed: {
    headers() {
      return {
        sessionId: this.$store.getters.token
      }
    }
  },
  methods: {
    remove(id) {
      const index = this.fileList.findIndex(p => p.fileId === id)
      this.fileList.splice(index, 1)
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning('1个文件体积超过20MB,不能进行上传.')
        return
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const fileSize = file.size
      this.fileList.push({ fileName: fileName, fileType: fileType, file: file.raw, fileSize: fileSize })
    }
  }
}
</script>

<style lang="scss">
  .process-content{
    .file-style{
      margin-top: 0px;
      width: 250px;
      height: 28px;
      background: linear-gradient(135deg,#f7faff, #ffffff);
      border-radius: 2px;
      display: inline-block;
    }
    .file-name{
      width: 50%;
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

</style>
